import FootballState from "../../../../../sports/football/state/football-state";
import { FragmentSerializer } from "./FragmentSerializer";

export class RougeFragmentSerializer extends FragmentSerializer {
    getRawFragment(play, serializationContext, fragment) {
        const { gameConfig } = serializationContext.gameContext;
        const { rougeYardline } = gameConfig.spots;
        const { fieldLength } = gameConfig.general;

        const { kickedBy, puntedBy } =
            play.getPreceedingFragment(fragment, [
                FootballState.Kick,
                FootballState.Punt,
                FootballState.CflKick
            ]) || {};

        const kickingPlayer = kickedBy || puntedBy;
        const kickingUniform = this.resolveUniform(
            serializationContext,
            kickingPlayer
        );
        const kickingTeam = this.resolveTeam(
            serializationContext,
            kickingPlayer
        );
        const receivingTeam = this.resolveOpponent(
            serializationContext,
            kickingPlayer
        );
        const formattedPosition = this.resolveFormattedFieldPosition(
            serializationContext,
            receivingTeam === "H" ? rougeYardline : fieldLength - rougeYardline
        );

        return `1PT:${kickingTeam},${kickingUniform} SPOT:${receivingTeam},${formattedPosition},Y`;
    }

    applicable(fragment) {
        return fragment.associatedState === FootballState.Rouge;
    }
}
